import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Titulo from '../comum/Titulo'
import { buscarFilaEncomendasAvulsas } from '../../util/offlineStorage'
import { sincronizarEncomendasAvulsasOffline } from '../../util/offlineSyncManagerEncomendaAvulsa'

class PainelListarEncomendasAvulsasOffline extends React.Component {
  constructor (props) {
    super(props)
    this.state = { encomendas: [], carregando: true }
  }

  componentDidMount () {
    this.carregarEncomendas()
    this.interval = setInterval(() => this.carregarEncomendas(), 10000)
  }

  componentWillUnmount () {
    clearInterval(this.interval)
  }

  async carregarEncomendas () {
    try {
      const fila = await buscarFilaEncomendasAvulsas() || []
      const idEmpresa = this.props.empresaSelecionada && this.props.empresaSelecionada.id
      const daEmpresa = idEmpresa
        ? fila.filter(e => e.dadosVenda && e.dadosVenda.empresaId === idEmpresa)
        : fila
      this.setState({ encomendas: daEmpresa, carregando: false })
    } catch (e) {
      this.setState({ encomendas: [], carregando: false })
    }
  }

  sincronizarAgora () {
    sincronizarEncomendasAvulsasOffline()
  }

  renderStatus (encomenda) {
    if (encomenda.erroSync) {
      return (
        <span className="vx-gp-badge vx-gp-badge--cancelado" title={encomenda.erroSync}>
          Erro: {encomenda.erroSync}
        </span>
      )
    }
    if (encomenda.statusServidor === 'PROCESSANDO') {
      return <span className="vx-gp-badge vx-gp-badge--processando">Em processamento...</span>
    }
    return <span className="vx-gp-badge vx-gp-badge--pendente">Pendente</span>
  }

  renderEncomenda (encomenda) {
    const dv = encomenda.dadosVenda || {}
    const descRota = encomenda.cidadeOrigemNome && encomenda.cidadeDestinoNome
      ? `${encomenda.cidadeOrigemNome} → ${encomenda.cidadeDestinoNome}`
      : '-'
    const ref = (encomenda.idChaveOffline || '').substring(0, 8)

    return (
      <div key={encomenda.idChaveOffline} className="vx-vo-row">
        <div className="vx-vo-cell" data-label="Ref.">
          <span className="vx-vo-ref">{ref}...</span>
        </div>
        <div className="vx-vo-cell" data-label="Empresa">
          {encomenda.empresaNome || '-'}
        </div>
        <div className="vx-vo-cell" data-label="Itinerário">
          {encomenda.itinerarioLabel || '-'}
        </div>
        <div className="vx-vo-cell" data-label="Trecho">
          {descRota}
        </div>
        <div className="vx-vo-cell" data-label="Destinatário">
          {encomenda.nomeDestinatario || dv.nomeDestinatario || '-'}
        </div>
        <div className="vx-vo-cell" data-label="Valor">
          {Number(encomenda.valorTotal || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
        </div>
        <div className="vx-vo-cell" data-label="Status">
          {this.renderStatus(encomenda)}
        </div>
      </div>
    )
  }

  render () {
    const { encomendas, carregando } = this.state

    return (
      <div className="row internas">
        <Titulo texto="Encomenda Avulsa Offline" urlRetorno="/painel-encomendas-avulsas" />
        <div className="col-12">
          <p className="text-muted" style={{ marginTop: -12, marginBottom: 16 }}>
            Encomendas avulsas vendidas sem conexão neste dispositivo, aguardando sincronização automática.
          </p>
          <div className="d-flex justify-content-end mb-3">
            <button className="vx-btn-secondary" onClick={() => this.sincronizarAgora()}>
              <i className="material-icons">sync</i> Sincronizar agora
            </button>
          </div>
          {carregando ? (
            <div className="text-center p-4">Carregando...</div>
          ) : encomendas.length === 0 ? (
            <div className="alert alert-info text-center">
              Nenhuma encomenda avulsa offline pendente neste dispositivo.
            </div>
          ) : (
            <div className="vx-vo-table">
              <div className="vx-vo-header">
                <div className="vx-vo-cell">Ref.</div>
                <div className="vx-vo-cell">Empresa</div>
                <div className="vx-vo-cell">Itinerário</div>
                <div className="vx-vo-cell">Trecho</div>
                <div className="vx-vo-cell">Destinatário</div>
                <div className="vx-vo-cell">Valor</div>
                <div className="vx-vo-cell">Status</div>
              </div>
              {encomendas.map(e => this.renderEncomenda(e))}
            </div>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  empresaSelecionada: state.empresaSelecionada
})

export default withRouter(connect(mapStateToProps)(PainelListarEncomendasAvulsasOffline))
